
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["timeoutPost","timeoutGet","timeoutPut"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "c37cb9f893bd1af4442d.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			